import { TFunction } from "i18next";

import { ApolloError } from "@apollo/client";

/**
 * WHO-6206. The gateway refuses a bid below the listing's minimum with this code. A bid placed
 * at the minimum the page showed can still fall below it when the hourly FX refresh lands
 * between showing the page and placing the bid: the page's minimum was converted at the old
 * rate.
 */
export const MINIMUM_BID_NOT_MET = "MINIMUM_BID_NOT_MET";

export const isMinimumBidNotMetError = (error: unknown) =>
  error instanceof ApolloError &&
  error.graphQLErrors.some(
    graphQLError => graphQLError.extensions?.code === MINIMUM_BID_NOT_MET
  );

/** What a failed bid tells the buyer: why, when the gateway says, else the generic error. */
export const bidErrorMessage = (error: unknown, translate: TFunction) =>
  isMinimumBidNotMetError(error)
    ? translate(
        "common:bid-minimum-not-met",
        "Your offer is below the minimum after the latest exchange rate update. Refresh the page to see the current minimum."
      )
    : translate("common:common_generic_error_message");
